import { render, staticRenderFns } from "./EditLabelGroup.vue?vue&type=template&id=5f35f13d&scoped=true"
import script from "./EditLabelGroup.vue?vue&type=script&lang=js"
export * from "./EditLabelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35f13d",
  null
  
)

export default component.exports